export const accordionData = [
  {
    id: 1,
    title: '¿Qué es XDNeo?',
    content: `Es una plataforma online desde la que podrás ver los programas de TV en vivo, películas y series, en cualquier dispositivo, momento y lugar con una conexión a Internet. Además, la calidad del video se adapta a tu velocidad de internet para que puedas mirar tus shows favoritos sin problemas.
    `
  },
  {
    id: 2,
    title: '¿Puedo ver programas ya emitidos?',
    content: `Sí, con XDNeo puedes retroceder y ver programas ya emitidos. También puedes reiniciar y pausar contenido cuando quieras.`
  },
  {
    id: 3,
    title: '¿Puedo grabar mis programas favoritos?',
    content: `Sí, XDNeo te permite grabar en la nube tus programas y películas favoritas para que las veas cuando lo desees.`
  }
];